/* tslint:disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v12.0.4.0 (NJsonSchema v9.12.7.0 (Newtonsoft.Json v10.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import 'rxjs/add/observable/fromPromise';
import 'rxjs/add/observable/of';
import 'rxjs/add/observable/throw';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/catch';

import { Observable } from 'rxjs/Observable';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

export interface IEvaluationService {
    getAll(): Observable<Evaluation[] | null>;
    post(evaluation: Evaluation): Observable<Evaluation | null>;
    put(evaluation: Evaluation): Observable<void>;
    getUserEvaluation(): Observable<Evaluation | null>;
    get(name: string | null): Observable<Evaluation | null>;
    delete(name: string | null): Observable<void>;
    startEvaluation(name: string | null, startEvaluationParameters: StartEvaluationParameters): Observable<void>;
    stopEvaluation(name: string | null): Observable<void>;
    getClientState(evaluationName: string | null, email: string | null): Observable<string | null>;
    startClient(evaluationName: string | null, email: string | null): Observable<void>;
    stopClient(evaluationName: string | null, email: string | null): Observable<void>;
    startServer(name: string | null): Observable<void>;
    stopServer(name: string | null): Observable<void>;
    eGNotifyDeploymentEvent(): Observable<FileResponse | null>;
    checkForEndedEvaluations(): Observable<void>;
}

@Injectable()
export class EvaluationService implements IEvaluationService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    getAll(): Observable<Evaluation[] | null> {
        let url_ = this.baseUrl + "/api/Evaluation";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetAll(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<Evaluation[] | null>><any>Observable.throw(e);
                }
            } else
                return <Observable<Evaluation[] | null>><any>Observable.throw(response_);
        });
    }

    protected processGetAll(response: HttpResponseBase): Observable<Evaluation[] | null> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(Evaluation.fromJS(item));
            }
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<Evaluation[] | null>(<any>null);
    }

    post(evaluation: Evaluation): Observable<Evaluation | null> {
        let url_ = this.baseUrl + "/api/Evaluation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(evaluation);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processPost(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPost(<any>response_);
                } catch (e) {
                    return <Observable<Evaluation | null>><any>Observable.throw(e);
                }
            } else
                return <Observable<Evaluation | null>><any>Observable.throw(response_);
        });
    }

    protected processPost(response: HttpResponseBase): Observable<Evaluation | null> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? Evaluation.fromJS(resultData200) : <any>null;
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<Evaluation | null>(<any>null);
    }

    put(evaluation: Evaluation): Observable<void> {
        let url_ = this.baseUrl + "/api/Evaluation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(evaluation);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("put", url_, options_).flatMap((response_ : any) => {
            return this.processPut(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPut(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processPut(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }

    getUserEvaluation(): Observable<Evaluation | null> {
        let url_ = this.baseUrl + "/api/Evaluation/getuserevaluation";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetUserEvaluation(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserEvaluation(<any>response_);
                } catch (e) {
                    return <Observable<Evaluation | null>><any>Observable.throw(e);
                }
            } else
                return <Observable<Evaluation | null>><any>Observable.throw(response_);
        });
    }

    protected processGetUserEvaluation(response: HttpResponseBase): Observable<Evaluation | null> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? Evaluation.fromJS(resultData200) : <any>null;
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<Evaluation | null>(<any>null);
    }

    get(name: string | null): Observable<Evaluation | null> {
        let url_ = this.baseUrl + "/api/Evaluation/{name}";
        if (name === undefined || name === null)
            throw new Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGet(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<Evaluation | null>><any>Observable.throw(e);
                }
            } else
                return <Observable<Evaluation | null>><any>Observable.throw(response_);
        });
    }

    protected processGet(response: HttpResponseBase): Observable<Evaluation | null> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? Evaluation.fromJS(resultData200) : <any>null;
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<Evaluation | null>(<any>null);
    }

    delete(name: string | null): Observable<void> {
        let url_ = this.baseUrl + "/api/Evaluation/{name}";
        if (name === undefined || name === null)
            throw new Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).flatMap((response_ : any) => {
            return this.processDelete(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }

    startEvaluation(name: string | null, startEvaluationParameters: StartEvaluationParameters): Observable<void> {
        let url_ = this.baseUrl + "/api/Evaluation/startevaluation/{name}";
        if (name === undefined || name === null)
            throw new Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(startEvaluationParameters);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processStartEvaluation(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStartEvaluation(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processStartEvaluation(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }

    stopEvaluation(name: string | null): Observable<void> {
        let url_ = this.baseUrl + "/api/Evaluation/stopevaluation/{name}";
        if (name === undefined || name === null)
            throw new Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processStopEvaluation(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStopEvaluation(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processStopEvaluation(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }

    getClientState(evaluationName: string | null, email: string | null): Observable<string | null> {
        let url_ = this.baseUrl + "/api/Evaluation/clientState/{evaluationName}/{email}";
        if (evaluationName === undefined || evaluationName === null)
            throw new Error("The parameter 'evaluationName' must be defined.");
        url_ = url_.replace("{evaluationName}", encodeURIComponent("" + evaluationName)); 
        if (email === undefined || email === null)
            throw new Error("The parameter 'email' must be defined.");
        url_ = url_.replace("{email}", encodeURIComponent("" + email)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetClientState(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetClientState(<any>response_);
                } catch (e) {
                    return <Observable<string | null>><any>Observable.throw(e);
                }
            } else
                return <Observable<string | null>><any>Observable.throw(response_);
        });
    }

    protected processGetClientState(response: HttpResponseBase): Observable<string | null> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<string | null>(<any>null);
    }

    startClient(evaluationName: string | null, email: string | null): Observable<void> {
        let url_ = this.baseUrl + "/api/Evaluation/startclient/{evaluationName}/{email}";
        if (evaluationName === undefined || evaluationName === null)
            throw new Error("The parameter 'evaluationName' must be defined.");
        url_ = url_.replace("{evaluationName}", encodeURIComponent("" + evaluationName)); 
        if (email === undefined || email === null)
            throw new Error("The parameter 'email' must be defined.");
        url_ = url_.replace("{email}", encodeURIComponent("" + email)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processStartClient(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStartClient(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processStartClient(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }

    stopClient(evaluationName: string | null, email: string | null): Observable<void> {
        let url_ = this.baseUrl + "/api/Evaluation/stopclient/{evaluationName}/{email}";
        if (evaluationName === undefined || evaluationName === null)
            throw new Error("The parameter 'evaluationName' must be defined.");
        url_ = url_.replace("{evaluationName}", encodeURIComponent("" + evaluationName)); 
        if (email === undefined || email === null)
            throw new Error("The parameter 'email' must be defined.");
        url_ = url_.replace("{email}", encodeURIComponent("" + email)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processStopClient(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStopClient(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processStopClient(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }

    startServer(name: string | null): Observable<void> {
        let url_ = this.baseUrl + "/api/Evaluation/startserver/{name}";
        if (name === undefined || name === null)
            throw new Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processStartServer(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStartServer(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processStartServer(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }

    stopServer(name: string | null): Observable<void> {
        let url_ = this.baseUrl + "/api/Evaluation/stopserver/{name}";
        if (name === undefined || name === null)
            throw new Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processStopServer(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStopServer(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processStopServer(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }

    eGNotifyDeploymentEvent(): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Evaluation/egdeploymentevent";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processEGNotifyDeploymentEvent(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEGNotifyDeploymentEvent(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse | null>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileResponse | null>><any>Observable.throw(response_);
        });
    }

    protected processEGNotifyDeploymentEvent(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Observable.of({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<FileResponse | null>(<any>null);
    }

    checkForEndedEvaluations(): Observable<void> {
        let url_ = this.baseUrl + "/api/Evaluation/checkended";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processCheckForEndedEvaluations(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckForEndedEvaluations(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCheckForEndedEvaluations(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }
}

export interface IFilesService {
    getUrl(file: string | null): Observable<string | null>;
    getUser(setFreshdeskProperties: boolean | undefined): Observable<User | null>;
    getContainerSAS(): Observable<string | null>;
    getTableSAS(): Observable<string | null>;
}

@Injectable()
export class FilesService implements IFilesService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    getUrl(file: string | null): Observable<string | null> {
        let url_ = this.baseUrl + "/api/Files/GetUrl/{file}";
        if (file === undefined || file === null)
            throw new Error("The parameter 'file' must be defined.");
        url_ = url_.replace("{file}", encodeURIComponent("" + file)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetUrl(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUrl(<any>response_);
                } catch (e) {
                    return <Observable<string | null>><any>Observable.throw(e);
                }
            } else
                return <Observable<string | null>><any>Observable.throw(response_);
        });
    }

    protected processGetUrl(response: HttpResponseBase): Observable<string | null> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<string | null>(<any>null);
    }

    getUser(setFreshdeskProperties: boolean | undefined): Observable<User | null> {
        let url_ = this.baseUrl + "/api/Files/GetUser?";
        if (setFreshdeskProperties === null)
            throw new Error("The parameter 'setFreshdeskProperties' cannot be null.");
        else if (setFreshdeskProperties !== undefined)
            url_ += "setFreshdeskProperties=" + encodeURIComponent("" + setFreshdeskProperties) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetUser(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUser(<any>response_);
                } catch (e) {
                    return <Observable<User | null>><any>Observable.throw(e);
                }
            } else
                return <Observable<User | null>><any>Observable.throw(response_);
        });
    }

    protected processGetUser(response: HttpResponseBase): Observable<User | null> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? User.fromJS(resultData200) : <any>null;
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<User | null>(<any>null);
    }

    getContainerSAS(): Observable<string | null> {
        let url_ = this.baseUrl + "/api/Files/GetContainerSAS";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetContainerSAS(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetContainerSAS(<any>response_);
                } catch (e) {
                    return <Observable<string | null>><any>Observable.throw(e);
                }
            } else
                return <Observable<string | null>><any>Observable.throw(response_);
        });
    }

    protected processGetContainerSAS(response: HttpResponseBase): Observable<string | null> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<string | null>(<any>null);
    }

    getTableSAS(): Observable<string | null> {
        let url_ = this.baseUrl + "/api/Files/GetTableSAS";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetTableSAS(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTableSAS(<any>response_);
                } catch (e) {
                    return <Observable<string | null>><any>Observable.throw(e);
                }
            } else
                return <Observable<string | null>><any>Observable.throw(response_);
        });
    }

    protected processGetTableSAS(response: HttpResponseBase): Observable<string | null> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<string | null>(<any>null);
    }
}

export interface IQaSessionService {
    getAll(): Observable<QaSession[] | null>;
    createQaSession(session: QaSession): Observable<QaSession | null>;
    updateQaSession(session: QaSession): Observable<QaSession | null>;
    delete(session: QaSession): Observable<void>;
    getQaSession(id: string | null): Observable<QaSession | null>;
    getComputers(session: QaSession): Observable<Computer[] | null>;
}

@Injectable()
export class QaSessionService implements IQaSessionService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    getAll(): Observable<QaSession[] | null> {
        let url_ = this.baseUrl + "/api/QaSession";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetAll(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<QaSession[] | null>><any>Observable.throw(e);
                }
            } else
                return <Observable<QaSession[] | null>><any>Observable.throw(response_);
        });
    }

    protected processGetAll(response: HttpResponseBase): Observable<QaSession[] | null> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(QaSession.fromJS(item));
            }
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<QaSession[] | null>(<any>null);
    }

    createQaSession(session: QaSession): Observable<QaSession | null> {
        let url_ = this.baseUrl + "/api/QaSession";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(session);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processCreateQaSession(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateQaSession(<any>response_);
                } catch (e) {
                    return <Observable<QaSession | null>><any>Observable.throw(e);
                }
            } else
                return <Observable<QaSession | null>><any>Observable.throw(response_);
        });
    }

    protected processCreateQaSession(response: HttpResponseBase): Observable<QaSession | null> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? QaSession.fromJS(resultData200) : <any>null;
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<QaSession | null>(<any>null);
    }

    updateQaSession(session: QaSession): Observable<QaSession | null> {
        let url_ = this.baseUrl + "/api/QaSession";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(session);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).flatMap((response_ : any) => {
            return this.processUpdateQaSession(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateQaSession(<any>response_);
                } catch (e) {
                    return <Observable<QaSession | null>><any>Observable.throw(e);
                }
            } else
                return <Observable<QaSession | null>><any>Observable.throw(response_);
        });
    }

    protected processUpdateQaSession(response: HttpResponseBase): Observable<QaSession | null> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? QaSession.fromJS(resultData200) : <any>null;
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<QaSession | null>(<any>null);
    }

    delete(session: QaSession): Observable<void> {
        let url_ = this.baseUrl + "/api/QaSession";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(session);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("delete", url_, options_).flatMap((response_ : any) => {
            return this.processDelete(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }

    getQaSession(id: string | null): Observable<QaSession | null> {
        let url_ = this.baseUrl + "/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetQaSession(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetQaSession(<any>response_);
                } catch (e) {
                    return <Observable<QaSession | null>><any>Observable.throw(e);
                }
            } else
                return <Observable<QaSession | null>><any>Observable.throw(response_);
        });
    }

    protected processGetQaSession(response: HttpResponseBase): Observable<QaSession | null> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? QaSession.fromJS(resultData200) : <any>null;
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<QaSession | null>(<any>null);
    }

    getComputers(session: QaSession): Observable<Computer[] | null> {
        let url_ = this.baseUrl + "/api/QaSession/computers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(session);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processGetComputers(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetComputers(<any>response_);
                } catch (e) {
                    return <Observable<Computer[] | null>><any>Observable.throw(e);
                }
            } else
                return <Observable<Computer[] | null>><any>Observable.throw(response_);
        });
    }

    protected processGetComputers(response: HttpResponseBase): Observable<Computer[] | null> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(Computer.fromJS(item));
            }
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<Computer[] | null>(<any>null);
    }
}

export interface IRegionsService {
    getList(): Observable<OptionList | null>;
}

@Injectable()
export class RegionsService implements IRegionsService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    getList(): Observable<OptionList | null> {
        let url_ = this.baseUrl + "/api/Regions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetList(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(<any>response_);
                } catch (e) {
                    return <Observable<OptionList | null>><any>Observable.throw(e);
                }
            } else
                return <Observable<OptionList | null>><any>Observable.throw(response_);
        });
    }

    protected processGetList(response: HttpResponseBase): Observable<OptionList | null> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? OptionList.fromJS(resultData200) : <any>null;
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<OptionList | null>(<any>null);
    }
}

export interface ITrainingCloudActivityService {
    getDeploymentState(trainingSessionId: string | null): Observable<ResourceDeploymentState>;
    deleteResources(trainingSessionId: string | null): Observable<void>;
    deploy(trainingSessionId: string | null): Observable<TrainingSession | null>;
    getTrainingComputers(trainingSessionId: string | null): Observable<Computer[] | null>;
    restartAllComputers(trainingSessionId: string | null): Observable<void>;
    stopAllComputers(trainingSessionId: string | null): Observable<void>;
    startAllComputers(trainingSessionId: string | null): Observable<void>;
    stopComputer(trainingSessionId: string | null, computerNumber: string | null): Observable<void>;
    startComputer(trainingSessionId: string | null, computerNumber: string | null): Observable<void>;
    restartComputer(trainingSessionId: string | null, computerNumber: string | null): Observable<void>;
}

@Injectable()
export class TrainingCloudActivityService implements ITrainingCloudActivityService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    getDeploymentState(trainingSessionId: string | null): Observable<ResourceDeploymentState> {
        let url_ = this.baseUrl + "/api/TrainingCloudActivity/{trainingSessionId}";
        if (trainingSessionId === undefined || trainingSessionId === null)
            throw new Error("The parameter 'trainingSessionId' must be defined.");
        url_ = url_.replace("{trainingSessionId}", encodeURIComponent("" + trainingSessionId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetDeploymentState(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDeploymentState(<any>response_);
                } catch (e) {
                    return <Observable<ResourceDeploymentState>><any>Observable.throw(e);
                }
            } else
                return <Observable<ResourceDeploymentState>><any>Observable.throw(response_);
        });
    }

    protected processGetDeploymentState(response: HttpResponseBase): Observable<ResourceDeploymentState> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<ResourceDeploymentState>(<any>null);
    }

    deleteResources(trainingSessionId: string | null): Observable<void> {
        let url_ = this.baseUrl + "/api/TrainingCloudActivity/{trainingSessionId}";
        if (trainingSessionId === undefined || trainingSessionId === null)
            throw new Error("The parameter 'trainingSessionId' must be defined.");
        url_ = url_.replace("{trainingSessionId}", encodeURIComponent("" + trainingSessionId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).flatMap((response_ : any) => {
            return this.processDeleteResources(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteResources(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeleteResources(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }

    deploy(trainingSessionId: string | null): Observable<TrainingSession | null> {
        let url_ = this.baseUrl + "/api/TrainingCloudActivity/{trainingSessionId}/deploy";
        if (trainingSessionId === undefined || trainingSessionId === null)
            throw new Error("The parameter 'trainingSessionId' must be defined.");
        url_ = url_.replace("{trainingSessionId}", encodeURIComponent("" + trainingSessionId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processDeploy(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeploy(<any>response_);
                } catch (e) {
                    return <Observable<TrainingSession | null>><any>Observable.throw(e);
                }
            } else
                return <Observable<TrainingSession | null>><any>Observable.throw(response_);
        });
    }

    protected processDeploy(response: HttpResponseBase): Observable<TrainingSession | null> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? TrainingSession.fromJS(resultData200) : <any>null;
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<TrainingSession | null>(<any>null);
    }

    getTrainingComputers(trainingSessionId: string | null): Observable<Computer[] | null> {
        let url_ = this.baseUrl + "/api/TrainingCloudActivity/{trainingSessionId}/computers";
        if (trainingSessionId === undefined || trainingSessionId === null)
            throw new Error("The parameter 'trainingSessionId' must be defined.");
        url_ = url_.replace("{trainingSessionId}", encodeURIComponent("" + trainingSessionId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetTrainingComputers(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTrainingComputers(<any>response_);
                } catch (e) {
                    return <Observable<Computer[] | null>><any>Observable.throw(e);
                }
            } else
                return <Observable<Computer[] | null>><any>Observable.throw(response_);
        });
    }

    protected processGetTrainingComputers(response: HttpResponseBase): Observable<Computer[] | null> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(Computer.fromJS(item));
            }
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<Computer[] | null>(<any>null);
    }

    restartAllComputers(trainingSessionId: string | null): Observable<void> {
        let url_ = this.baseUrl + "/api/TrainingCloudActivity/{trainingSessionId}/restartall";
        if (trainingSessionId === undefined || trainingSessionId === null)
            throw new Error("The parameter 'trainingSessionId' must be defined.");
        url_ = url_.replace("{trainingSessionId}", encodeURIComponent("" + trainingSessionId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processRestartAllComputers(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRestartAllComputers(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processRestartAllComputers(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }

    stopAllComputers(trainingSessionId: string | null): Observable<void> {
        let url_ = this.baseUrl + "/api/TrainingCloudActivity/{trainingSessionId}/stopall";
        if (trainingSessionId === undefined || trainingSessionId === null)
            throw new Error("The parameter 'trainingSessionId' must be defined.");
        url_ = url_.replace("{trainingSessionId}", encodeURIComponent("" + trainingSessionId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processStopAllComputers(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStopAllComputers(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processStopAllComputers(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }

    startAllComputers(trainingSessionId: string | null): Observable<void> {
        let url_ = this.baseUrl + "/api/TrainingCloudActivity/{trainingSessionId}/startall";
        if (trainingSessionId === undefined || trainingSessionId === null)
            throw new Error("The parameter 'trainingSessionId' must be defined.");
        url_ = url_.replace("{trainingSessionId}", encodeURIComponent("" + trainingSessionId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processStartAllComputers(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStartAllComputers(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processStartAllComputers(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }

    stopComputer(trainingSessionId: string | null, computerNumber: string | null): Observable<void> {
        let url_ = this.baseUrl + "/api/TrainingCloudActivity/{trainingSessionId}/stop/{computerNumber}";
        if (trainingSessionId === undefined || trainingSessionId === null)
            throw new Error("The parameter 'trainingSessionId' must be defined.");
        url_ = url_.replace("{trainingSessionId}", encodeURIComponent("" + trainingSessionId)); 
        if (computerNumber === undefined || computerNumber === null)
            throw new Error("The parameter 'computerNumber' must be defined.");
        url_ = url_.replace("{computerNumber}", encodeURIComponent("" + computerNumber)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processStopComputer(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStopComputer(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processStopComputer(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }

    startComputer(trainingSessionId: string | null, computerNumber: string | null): Observable<void> {
        let url_ = this.baseUrl + "/api/TrainingCloudActivity/{trainingSessionId}/start/{computerNumber}";
        if (trainingSessionId === undefined || trainingSessionId === null)
            throw new Error("The parameter 'trainingSessionId' must be defined.");
        url_ = url_.replace("{trainingSessionId}", encodeURIComponent("" + trainingSessionId)); 
        if (computerNumber === undefined || computerNumber === null)
            throw new Error("The parameter 'computerNumber' must be defined.");
        url_ = url_.replace("{computerNumber}", encodeURIComponent("" + computerNumber)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processStartComputer(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStartComputer(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processStartComputer(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }

    restartComputer(trainingSessionId: string | null, computerNumber: string | null): Observable<void> {
        let url_ = this.baseUrl + "/api/TrainingCloudActivity/{trainingSessionId}/restart/{computerNumber}";
        if (trainingSessionId === undefined || trainingSessionId === null)
            throw new Error("The parameter 'trainingSessionId' must be defined.");
        url_ = url_.replace("{trainingSessionId}", encodeURIComponent("" + trainingSessionId)); 
        if (computerNumber === undefined || computerNumber === null)
            throw new Error("The parameter 'computerNumber' must be defined.");
        url_ = url_.replace("{computerNumber}", encodeURIComponent("" + computerNumber)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processRestartComputer(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRestartComputer(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processRestartComputer(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }
}

export interface ITrainingSessionService {
    getById(id: string | null): Observable<TrainingSession | null>;
    put(id: string | null, trainingSession: TrainingSession): Observable<TrainingSession | null>;
    delete(id: string | null): Observable<void>;
    getAll(): Observable<TrainingSession[] | null>;
    post(trainingSession: TrainingSession): Observable<TrainingSession | null>;
    filter(idFilter: string | null | undefined, instructorFilter: string | null | undefined, eventNameFilter: string | null | undefined, trainingStudentFilter: string | null | undefined, startedOnOrAfter: Date | null | undefined, startedBefore: Date | null | undefined, endedOnOrAfter: Date | null | undefined, endedBefore: Date | null | undefined, locationFilter: string | null | undefined, courseNameFilter: string | null | undefined, notesFilter: string | null | undefined, cloudResourcesEnabled: boolean | null | undefined, createdByFilter: string | null | undefined, createdOnOrAfter: Date | null | undefined, createdBefore: Date | null | undefined, modifiedByFilter: string | null | undefined, modifiedOnOrAfter: Date | null | undefined, modifiedBefore: Date | null | undefined): Observable<TrainingSession[] | null>;
    mailAll(id: string | null): Observable<void>;
}

@Injectable()
export class TrainingSessionService implements ITrainingSessionService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    getById(id: string | null): Observable<TrainingSession | null> {
        let url_ = this.baseUrl + "/api/TrainingSession/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetById(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(<any>response_);
                } catch (e) {
                    return <Observable<TrainingSession | null>><any>Observable.throw(e);
                }
            } else
                return <Observable<TrainingSession | null>><any>Observable.throw(response_);
        });
    }

    protected processGetById(response: HttpResponseBase): Observable<TrainingSession | null> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? TrainingSession.fromJS(resultData200) : <any>null;
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<TrainingSession | null>(<any>null);
    }

    put(id: string | null, trainingSession: TrainingSession): Observable<TrainingSession | null> {
        let url_ = this.baseUrl + "/api/TrainingSession/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(trainingSession);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).flatMap((response_ : any) => {
            return this.processPut(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPut(<any>response_);
                } catch (e) {
                    return <Observable<TrainingSession | null>><any>Observable.throw(e);
                }
            } else
                return <Observable<TrainingSession | null>><any>Observable.throw(response_);
        });
    }

    protected processPut(response: HttpResponseBase): Observable<TrainingSession | null> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? TrainingSession.fromJS(resultData200) : <any>null;
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<TrainingSession | null>(<any>null);
    }

    delete(id: string | null): Observable<void> {
        let url_ = this.baseUrl + "/api/TrainingSession/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).flatMap((response_ : any) => {
            return this.processDelete(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }

    getAll(): Observable<TrainingSession[] | null> {
        let url_ = this.baseUrl + "/api/TrainingSession";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGetAll(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<TrainingSession[] | null>><any>Observable.throw(e);
                }
            } else
                return <Observable<TrainingSession[] | null>><any>Observable.throw(response_);
        });
    }

    protected processGetAll(response: HttpResponseBase): Observable<TrainingSession[] | null> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(TrainingSession.fromJS(item));
            }
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<TrainingSession[] | null>(<any>null);
    }

    post(trainingSession: TrainingSession): Observable<TrainingSession | null> {
        let url_ = this.baseUrl + "/api/TrainingSession";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(trainingSession);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processPost(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPost(<any>response_);
                } catch (e) {
                    return <Observable<TrainingSession | null>><any>Observable.throw(e);
                }
            } else
                return <Observable<TrainingSession | null>><any>Observable.throw(response_);
        });
    }

    protected processPost(response: HttpResponseBase): Observable<TrainingSession | null> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? TrainingSession.fromJS(resultData200) : <any>null;
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<TrainingSession | null>(<any>null);
    }

    filter(idFilter: string | null | undefined, instructorFilter: string | null | undefined, eventNameFilter: string | null | undefined, trainingStudentFilter: string | null | undefined, startedOnOrAfter: Date | null | undefined, startedBefore: Date | null | undefined, endedOnOrAfter: Date | null | undefined, endedBefore: Date | null | undefined, locationFilter: string | null | undefined, courseNameFilter: string | null | undefined, notesFilter: string | null | undefined, cloudResourcesEnabled: boolean | null | undefined, createdByFilter: string | null | undefined, createdOnOrAfter: Date | null | undefined, createdBefore: Date | null | undefined, modifiedByFilter: string | null | undefined, modifiedOnOrAfter: Date | null | undefined, modifiedBefore: Date | null | undefined): Observable<TrainingSession[] | null> {
        let url_ = this.baseUrl + "/api/TrainingSession/filter?";
        if (idFilter !== undefined)
            url_ += "IdFilter=" + encodeURIComponent("" + idFilter) + "&"; 
        if (instructorFilter !== undefined)
            url_ += "InstructorFilter=" + encodeURIComponent("" + instructorFilter) + "&"; 
        if (eventNameFilter !== undefined)
            url_ += "EventNameFilter=" + encodeURIComponent("" + eventNameFilter) + "&"; 
        if (trainingStudentFilter !== undefined)
            url_ += "TrainingStudentFilter=" + encodeURIComponent("" + trainingStudentFilter) + "&"; 
        if (startedOnOrAfter !== undefined)
            url_ += "StartedOnOrAfter=" + encodeURIComponent(startedOnOrAfter ? "" + startedOnOrAfter.toJSON() : "") + "&"; 
        if (startedBefore !== undefined)
            url_ += "StartedBefore=" + encodeURIComponent(startedBefore ? "" + startedBefore.toJSON() : "") + "&"; 
        if (endedOnOrAfter !== undefined)
            url_ += "EndedOnOrAfter=" + encodeURIComponent(endedOnOrAfter ? "" + endedOnOrAfter.toJSON() : "") + "&"; 
        if (endedBefore !== undefined)
            url_ += "EndedBefore=" + encodeURIComponent(endedBefore ? "" + endedBefore.toJSON() : "") + "&"; 
        if (locationFilter !== undefined)
            url_ += "LocationFilter=" + encodeURIComponent("" + locationFilter) + "&"; 
        if (courseNameFilter !== undefined)
            url_ += "CourseNameFilter=" + encodeURIComponent("" + courseNameFilter) + "&"; 
        if (notesFilter !== undefined)
            url_ += "NotesFilter=" + encodeURIComponent("" + notesFilter) + "&"; 
        if (cloudResourcesEnabled !== undefined)
            url_ += "CloudResourcesEnabled=" + encodeURIComponent("" + cloudResourcesEnabled) + "&"; 
        if (createdByFilter !== undefined)
            url_ += "CreatedByFilter=" + encodeURIComponent("" + createdByFilter) + "&"; 
        if (createdOnOrAfter !== undefined)
            url_ += "CreatedOnOrAfter=" + encodeURIComponent(createdOnOrAfter ? "" + createdOnOrAfter.toJSON() : "") + "&"; 
        if (createdBefore !== undefined)
            url_ += "CreatedBefore=" + encodeURIComponent(createdBefore ? "" + createdBefore.toJSON() : "") + "&"; 
        if (modifiedByFilter !== undefined)
            url_ += "ModifiedByFilter=" + encodeURIComponent("" + modifiedByFilter) + "&"; 
        if (modifiedOnOrAfter !== undefined)
            url_ += "ModifiedOnOrAfter=" + encodeURIComponent(modifiedOnOrAfter ? "" + modifiedOnOrAfter.toJSON() : "") + "&"; 
        if (modifiedBefore !== undefined)
            url_ += "ModifiedBefore=" + encodeURIComponent(modifiedBefore ? "" + modifiedBefore.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processFilter(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFilter(<any>response_);
                } catch (e) {
                    return <Observable<TrainingSession[] | null>><any>Observable.throw(e);
                }
            } else
                return <Observable<TrainingSession[] | null>><any>Observable.throw(response_);
        });
    }

    protected processFilter(response: HttpResponseBase): Observable<TrainingSession[] | null> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(TrainingSession.fromJS(item));
            }
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<TrainingSession[] | null>(<any>null);
    }

    mailAll(id: string | null): Observable<void> {
        let url_ = this.baseUrl + "/api/TrainingSession/mailall/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).flatMap((response_ : any) => {
            return this.processMailAll(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMailAll(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processMailAll(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).flatMap(_responseText => {
            return Observable.of<void>(<any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<void>(<any>null);
    }
}

export interface ITrainingSessionUserService {
    get(studentId: string | null): Observable<TrainingSessionUser | null>;
}

@Injectable()
export class TrainingSessionUserService implements ITrainingSessionUserService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    get(studentId: string | null): Observable<TrainingSessionUser | null> {
        let url_ = this.baseUrl + "/api/TrainingSessionUser/{studentId}";
        if (studentId === undefined || studentId === null)
            throw new Error("The parameter 'studentId' must be defined.");
        url_ = url_.replace("{studentId}", encodeURIComponent("" + studentId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).flatMap((response_ : any) => {
            return this.processGet(response_);
        }).catch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<TrainingSessionUser | null>><any>Observable.throw(e);
                }
            } else
                return <Observable<TrainingSessionUser | null>><any>Observable.throw(response_);
        });
    }

    protected processGet(response: HttpResponseBase): Observable<TrainingSessionUser | null> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).flatMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? TrainingSessionUser.fromJS(resultData200) : <any>null;
            return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<TrainingSessionUser | null>(<any>null);
    }
}

export abstract class EntityBase implements IEntityBase {
    id?: string | undefined;
    __type?: string | undefined;
    createdBy?: string | undefined;
    createdDate?: Date | undefined;
    modifiedBy?: string | undefined;
    modifiedDate?: Date | undefined;

    constructor(data?: IEntityBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.__type = data["__type"];
            this.createdBy = data["createdBy"];
            this.createdDate = data["createdDate"] ? new Date(data["createdDate"].toString()) : <any>undefined;
            this.modifiedBy = data["modifiedBy"];
            this.modifiedDate = data["modifiedDate"] ? new Date(data["modifiedDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): EntityBase {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'EntityBase' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["__type"] = this.__type;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedDate"] = this.modifiedDate ? this.modifiedDate.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IEntityBase {
    id?: string | undefined;
    __type?: string | undefined;
    createdBy?: string | undefined;
    createdDate?: Date | undefined;
    modifiedBy?: string | undefined;
    modifiedDate?: Date | undefined;
}

export abstract class VmActivityBase extends EntityBase implements IVmActivityBase {
    name?: string | undefined;
    displayName?: string | undefined;
    state?: string | undefined;
    start: Date;
    end: Date;
    resourceGroupId?: string | undefined;
    paradiseVersion?: string | undefined;

    constructor(data?: IVmActivityBase) {
        super(data);
    }

    init(data?: any) {
        super.init(data);
        if (data) {
            this.name = data["name"];
            this.displayName = data["displayName"];
            this.state = data["state"];
            this.start = data["start"] ? new Date(data["start"].toString()) : <any>undefined;
            this.end = data["end"] ? new Date(data["end"].toString()) : <any>undefined;
            this.resourceGroupId = data["resourceGroupId"];
            this.paradiseVersion = data["paradiseVersion"];
        }
    }

    static fromJS(data: any): VmActivityBase {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'VmActivityBase' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["state"] = this.state;
        data["start"] = this.start ? this.start.toISOString() : <any>undefined;
        data["end"] = this.end ? this.end.toISOString() : <any>undefined;
        data["resourceGroupId"] = this.resourceGroupId;
        data["paradiseVersion"] = this.paradiseVersion;
        super.toJSON(data);
        return data; 
    }
}

export interface IVmActivityBase extends IEntityBase {
    name?: string | undefined;
    displayName?: string | undefined;
    state?: string | undefined;
    start: Date;
    end: Date;
    resourceGroupId?: string | undefined;
    paradiseVersion?: string | undefined;
}

export class Evaluation extends VmActivityBase implements IEvaluation {
    clients?: Computer[] | undefined;
    server?: Computer | undefined;
    users?: string[] | undefined;
    interactiveCredits: number;
    interactiveCreditsUsed: number;
    notes?: string | undefined;
    serverVmSize?: string | undefined;
    vmUserName?: string | undefined;
    vmPassword?: string | undefined;
    regionName?: string | undefined;

    constructor(data?: IEvaluation) {
        super(data);
    }

    init(data?: any) {
        super.init(data);
        if (data) {
            if (data["clients"] && data["clients"].constructor === Array) {
                this.clients = [];
                for (let item of data["clients"])
                    this.clients.push(Computer.fromJS(item));
            }
            this.server = data["server"] ? Computer.fromJS(data["server"]) : <any>undefined;
            if (data["users"] && data["users"].constructor === Array) {
                this.users = [];
                for (let item of data["users"])
                    this.users.push(item);
            }
            this.interactiveCredits = data["interactiveCredits"];
            this.interactiveCreditsUsed = data["interactiveCreditsUsed"];
            this.notes = data["notes"];
            this.serverVmSize = data["serverVmSize"];
            this.vmUserName = data["vmUserName"];
            this.vmPassword = data["vmPassword"];
            this.regionName = data["regionName"];
        }
    }

    static fromJS(data: any): Evaluation {
        data = typeof data === 'object' ? data : {};
        let result = new Evaluation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.clients && this.clients.constructor === Array) {
            data["clients"] = [];
            for (let item of this.clients)
                data["clients"].push(item.toJSON());
        }
        data["server"] = this.server ? this.server.toJSON() : <any>undefined;
        if (this.users && this.users.constructor === Array) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item);
        }
        data["interactiveCredits"] = this.interactiveCredits;
        data["interactiveCreditsUsed"] = this.interactiveCreditsUsed;
        data["notes"] = this.notes;
        data["serverVmSize"] = this.serverVmSize;
        data["vmUserName"] = this.vmUserName;
        data["vmPassword"] = this.vmPassword;
        data["regionName"] = this.regionName;
        super.toJSON(data);
        return data; 
    }
}

export interface IEvaluation extends IVmActivityBase {
    clients?: Computer[] | undefined;
    server?: Computer | undefined;
    users?: string[] | undefined;
    interactiveCredits: number;
    interactiveCreditsUsed: number;
    notes?: string | undefined;
    serverVmSize?: string | undefined;
    vmUserName?: string | undefined;
    vmPassword?: string | undefined;
    regionName?: string | undefined;
}

export class Computer implements IComputer {
    isServer: boolean;
    resourceId?: string | undefined;
    state?: string | undefined;
    user?: string | undefined;
    computerName?: string | undefined;
    ipAddress?: string | undefined;
    computerNumber?: string | undefined;

    constructor(data?: IComputer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isServer = data["isServer"];
            this.resourceId = data["resourceId"];
            this.state = data["state"];
            this.user = data["user"];
            this.computerName = data["computerName"];
            this.ipAddress = data["ipAddress"];
            this.computerNumber = data["computerNumber"];
        }
    }

    static fromJS(data: any): Computer {
        data = typeof data === 'object' ? data : {};
        let result = new Computer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isServer"] = this.isServer;
        data["resourceId"] = this.resourceId;
        data["state"] = this.state;
        data["user"] = this.user;
        data["computerName"] = this.computerName;
        data["ipAddress"] = this.ipAddress;
        data["computerNumber"] = this.computerNumber;
        return data; 
    }
}

export interface IComputer {
    isServer: boolean;
    resourceId?: string | undefined;
    state?: string | undefined;
    user?: string | undefined;
    computerName?: string | undefined;
    ipAddress?: string | undefined;
    computerNumber?: string | undefined;
}

export class StartEvaluationParameters implements IStartEvaluationParameters {
    userName?: string | undefined;
    password?: string | undefined;

    constructor(data?: IStartEvaluationParameters) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.userName = data["userName"];
            this.password = data["password"];
        }
    }

    static fromJS(data: any): StartEvaluationParameters {
        data = typeof data === 'object' ? data : {};
        let result = new StartEvaluationParameters();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["password"] = this.password;
        return data; 
    }
}

export interface IStartEvaluationParameters {
    userName?: string | undefined;
    password?: string | undefined;
}

export class User implements IUser {
    email?: string | undefined;
    isAdmin: boolean;
    isBetaUser: boolean;
    isArchiveUser: boolean;

    constructor(data?: IUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.email = data["email"];
            this.isAdmin = data["isAdmin"];
            this.isBetaUser = data["isBetaUser"];
            this.isArchiveUser = data["isArchiveUser"];
        }
    }

    static fromJS(data: any): User {
        data = typeof data === 'object' ? data : {};
        let result = new User();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["isAdmin"] = this.isAdmin;
        data["isBetaUser"] = this.isBetaUser;
        data["isArchiveUser"] = this.isArchiveUser;
        return data; 
    }
}

export interface IUser {
    email?: string | undefined;
    isAdmin: boolean;
    isBetaUser: boolean;
    isArchiveUser: boolean;
}

export class QaSession extends EntityBase implements IQaSession {
    name: string;
    paradiseVersion: string;
    resourceGroupName?: string | undefined;

    constructor(data?: IQaSession) {
        super(data);
    }

    init(data?: any) {
        super.init(data);
        if (data) {
            this.name = data["name"];
            this.paradiseVersion = data["paradiseVersion"];
            this.resourceGroupName = data["resourceGroupName"];
        }
    }

    static fromJS(data: any): QaSession {
        data = typeof data === 'object' ? data : {};
        let result = new QaSession();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["paradiseVersion"] = this.paradiseVersion;
        data["resourceGroupName"] = this.resourceGroupName;
        super.toJSON(data);
        return data; 
    }
}

export interface IQaSession extends IEntityBase {
    name: string;
    paradiseVersion: string;
    resourceGroupName?: string | undefined;
}

export class OptionList implements IOptionList {
    options?: ListOption[] | undefined;

    constructor(data?: IOptionList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["options"] && data["options"].constructor === Array) {
                this.options = [];
                for (let item of data["options"])
                    this.options.push(ListOption.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OptionList {
        data = typeof data === 'object' ? data : {};
        let result = new OptionList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.options && this.options.constructor === Array) {
            data["options"] = [];
            for (let item of this.options)
                data["options"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IOptionList {
    options?: ListOption[] | undefined;
}

export class ListOption implements IListOption {
    key?: string | undefined;
    displayName?: string | undefined;

    constructor(data?: IListOption) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.key = data["key"];
            this.displayName = data["displayName"];
        }
    }

    static fromJS(data: any): ListOption {
        data = typeof data === 'object' ? data : {};
        let result = new ListOption();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["displayName"] = this.displayName;
        return data; 
    }
}

export interface IListOption {
    key?: string | undefined;
    displayName?: string | undefined;
}

export enum ResourceDeploymentState {
    Unknown = 0, 
    Accepted = 1, 
    Canceled = 2, 
    Created = 3, 
    Creating = 4, 
    Deleted = 5, 
    Deleting = 6, 
    Failed = 7, 
    NotSpecified = 8, 
    Registering = 9, 
    Running = 10, 
    Succeeded = 11, 
}

export class TrainingSession extends EntityBase implements ITrainingSession {
    instructor?: string | undefined;
    eventName: string;
    trainingStudents?: TrainingStudent[] | undefined;
    startDate: Date;
    endDate: Date;
    location?: string | undefined;
    courseName: string;
    notes?: string | undefined;
    enableCloudResources: boolean;
    isDeployed: boolean;
    isCloudDeleted: boolean;
    cloudResourceGroupName?: string | undefined;
    cloudResourcesUserName?: string | undefined;
    cloudResourcesPasswordPrefix?: string | undefined;
    cloudRegionName?: string | undefined;
    cloudParadiseVersion?: string | undefined;
    cloudDeploymentName?: string | undefined;

    constructor(data?: ITrainingSession) {
        super(data);
    }

    init(data?: any) {
        super.init(data);
        if (data) {
            this.instructor = data["instructor"];
            this.eventName = data["eventName"];
            if (data["trainingStudents"] && data["trainingStudents"].constructor === Array) {
                this.trainingStudents = [];
                for (let item of data["trainingStudents"])
                    this.trainingStudents.push(TrainingStudent.fromJS(item));
            }
            this.startDate = data["startDate"] ? new Date(data["startDate"].toString()) : <any>undefined;
            this.endDate = data["endDate"] ? new Date(data["endDate"].toString()) : <any>undefined;
            this.location = data["location"];
            this.courseName = data["courseName"];
            this.notes = data["notes"];
            this.enableCloudResources = data["enableCloudResources"];
            this.isDeployed = data["isDeployed"];
            this.isCloudDeleted = data["isCloudDeleted"];
            this.cloudResourceGroupName = data["cloudResourceGroupName"];
            this.cloudResourcesUserName = data["cloudResourcesUserName"];
            this.cloudResourcesPasswordPrefix = data["cloudResourcesPasswordPrefix"];
            this.cloudRegionName = data["cloudRegionName"];
            this.cloudParadiseVersion = data["cloudParadiseVersion"];
            this.cloudDeploymentName = data["cloudDeploymentName"];
        }
    }

    static fromJS(data: any): TrainingSession {
        data = typeof data === 'object' ? data : {};
        let result = new TrainingSession();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["instructor"] = this.instructor;
        data["eventName"] = this.eventName;
        if (this.trainingStudents && this.trainingStudents.constructor === Array) {
            data["trainingStudents"] = [];
            for (let item of this.trainingStudents)
                data["trainingStudents"].push(item.toJSON());
        }
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["location"] = this.location;
        data["courseName"] = this.courseName;
        data["notes"] = this.notes;
        data["enableCloudResources"] = this.enableCloudResources;
        data["isDeployed"] = this.isDeployed;
        data["isCloudDeleted"] = this.isCloudDeleted;
        data["cloudResourceGroupName"] = this.cloudResourceGroupName;
        data["cloudResourcesUserName"] = this.cloudResourcesUserName;
        data["cloudResourcesPasswordPrefix"] = this.cloudResourcesPasswordPrefix;
        data["cloudRegionName"] = this.cloudRegionName;
        data["cloudParadiseVersion"] = this.cloudParadiseVersion;
        data["cloudDeploymentName"] = this.cloudDeploymentName;
        super.toJSON(data);
        return data; 
    }
}

export interface ITrainingSession extends IEntityBase {
    instructor?: string | undefined;
    eventName: string;
    trainingStudents?: TrainingStudent[] | undefined;
    startDate: Date;
    endDate: Date;
    location?: string | undefined;
    courseName: string;
    notes?: string | undefined;
    enableCloudResources: boolean;
    isDeployed: boolean;
    isCloudDeleted: boolean;
    cloudResourceGroupName?: string | undefined;
    cloudResourcesUserName?: string | undefined;
    cloudResourcesPasswordPrefix?: string | undefined;
    cloudRegionName?: string | undefined;
    cloudParadiseVersion?: string | undefined;
    cloudDeploymentName?: string | undefined;
}

export class TrainingStudent implements ITrainingStudent {
    studentId?: string | undefined;
    name?: string | undefined;
    email?: string | undefined;
    number?: string | undefined;

    constructor(data?: ITrainingStudent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.studentId = data["studentId"];
            this.name = data["name"];
            this.email = data["email"];
            this.number = data["number"];
        }
    }

    static fromJS(data: any): TrainingStudent {
        data = typeof data === 'object' ? data : {};
        let result = new TrainingStudent();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["studentId"] = this.studentId;
        data["name"] = this.name;
        data["email"] = this.email;
        data["number"] = this.number;
        return data; 
    }
}

export interface ITrainingStudent {
    studentId?: string | undefined;
    name?: string | undefined;
    email?: string | undefined;
    number?: string | undefined;
}

export class TrainingSessionUser implements ITrainingSessionUser {
    instructor?: string | undefined;
    eventName?: string | undefined;
    targetStudent?: TrainingStudent | undefined;
    startDate: Date;
    endDate: Date;
    location?: string | undefined;
    courseName?: string | undefined;
    notes?: string | undefined;
    cloudEnabled: boolean;
    trainingSessionId?: string | undefined;
    trainingSessionDeploymentName?: string | undefined;
    userName?: string | undefined;
    password?: string | undefined;
    targetComputer?: Computer | undefined;

    constructor(data?: ITrainingSessionUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.instructor = data["instructor"];
            this.eventName = data["eventName"];
            this.targetStudent = data["targetStudent"] ? TrainingStudent.fromJS(data["targetStudent"]) : <any>undefined;
            this.startDate = data["startDate"] ? new Date(data["startDate"].toString()) : <any>undefined;
            this.endDate = data["endDate"] ? new Date(data["endDate"].toString()) : <any>undefined;
            this.location = data["location"];
            this.courseName = data["courseName"];
            this.notes = data["notes"];
            this.cloudEnabled = data["cloudEnabled"];
            this.trainingSessionId = data["trainingSessionId"];
            this.trainingSessionDeploymentName = data["trainingSessionDeploymentName"];
            this.userName = data["userName"];
            this.password = data["password"];
            this.targetComputer = data["targetComputer"] ? Computer.fromJS(data["targetComputer"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TrainingSessionUser {
        data = typeof data === 'object' ? data : {};
        let result = new TrainingSessionUser();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["instructor"] = this.instructor;
        data["eventName"] = this.eventName;
        data["targetStudent"] = this.targetStudent ? this.targetStudent.toJSON() : <any>undefined;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["location"] = this.location;
        data["courseName"] = this.courseName;
        data["notes"] = this.notes;
        data["cloudEnabled"] = this.cloudEnabled;
        data["trainingSessionId"] = this.trainingSessionId;
        data["trainingSessionDeploymentName"] = this.trainingSessionDeploymentName;
        data["userName"] = this.userName;
        data["password"] = this.password;
        data["targetComputer"] = this.targetComputer ? this.targetComputer.toJSON() : <any>undefined;
        return data; 
    }
}

export interface ITrainingSessionUser {
    instructor?: string | undefined;
    eventName?: string | undefined;
    targetStudent?: TrainingStudent | undefined;
    startDate: Date;
    endDate: Date;
    location?: string | undefined;
    courseName?: string | undefined;
    notes?: string | undefined;
    cloudEnabled: boolean;
    trainingSessionId?: string | undefined;
    trainingSessionDeploymentName?: string | undefined;
    userName?: string | undefined;
    password?: string | undefined;
    targetComputer?: Computer | undefined;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class SwaggerException extends Error {
    message: string;
    status: number; 
    response: string; 
    headers: { [key: string]: any; };
    result: any; 

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if(result !== null && result !== undefined)
        return Observable.throw(result);
    else
        return Observable.throw(new SwaggerException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader(); 
            reader.onload = event => { 
                observer.next((<any>event.target).result);
                observer.complete();
            };
            reader.readAsText(blob); 
        }
    });
}


// WEBPACK FOOTER //
// ./src/app/services/GI.Web.Services.g.ts